module.exports = __webpack_public_path__ + "img/chart.831dcc0c.jpg";